import { Typography } from "antd";

import { type BadgeStatus, RVStatusBadge } from "../../atoms";

import styles from "./RVStatusSelectOption.module.scss";

/**
 * Props for the RVStatusSelectOption component.
 */
export type RVStatusSelectOptionProps = {
    /** Primary label text shown on the left. */
    name: string;
    /** Status type that determines the badge's visual styling. */
    badgeStatus: BadgeStatus;
    /** Text content rendered inside the status badge on the right. */
    badgeContent: string;
};

/**
 * Renders a select option row with a name on the left and a status badge on the right.
 *
 * Intended for use as the `label` of an Ant Design `Select` option where each option needs
 * to convey a status alongside its name.
 *
 * @param props - Component props.
 * @returns A row containing the option name and a status badge.
 *
 * @example
 * ```tsx
 * <RVStatusSelectOption name="Send Email" badgeStatus={BADGE_STATUS.ACTIVE} badgeContent="active" />
 * ```
 */
export function RVStatusSelectOption({ name, badgeStatus, badgeContent }: RVStatusSelectOptionProps): JSX.Element {
    return (
        <span className={styles.option}>
            <Typography.Text className={styles.text}>{name}</Typography.Text>
            <RVStatusBadge status={badgeStatus} content={badgeContent} />
        </span>
    );
}
